import React from 'react';
import './css/popupstyle.css';
import $ from 'jquery';

class Popup extends React.Component {
    
    constructor(props) {
        super(props);
        this.state = {
            wname: this.props.wholesaler_name,
            loader: true
        };
    }
    hideSpinner = () => {
        this.setState({ loader: false });
    }
    render() {
        const { loader } = this.state;
        let IframeURL = "";//"https://cnd.23byt.es/";
        if (this.state.wname == "Admin") {
            IframeURL = IframeURL + 'home/iadmin';
        }
        else {
            IframeURL = IframeURL + 'home/uindex?wholeseller=' + this.state.wname;
        }
        return (
            <div className='popup manage-scroll admin-manage-group-number'>
                <div className='popup_inner'>
                    <h1>{this.props.text}<button onClick={this.props.closePopup}>X</button></h1>
                    {
                        loader ? <div className="theme-loader"></div> : null                 
                    }
                    <div className="iframe-responsive">
                        <iframe src={IframeURL} onLoad={this.hideSpinner} />
                    </div>
                </div>
            </div>
        );
    }
}


export default Popup;